import { Component, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { CardActions } from '../../user.model';

@Component({
    selector: 'app-user-card-request-approval-not-needed-dialog',
    templateUrl: './user-card-request-approval-not-needed-dialog.component.html',
    styleUrls: ['./user-card-request-approval-not-needed-dialog.component.scss'],
})
export class UserCardRequestApprovalNotNeededDialogComponent implements OnDestroy {
    public destroy$ = new Subject();

    CardActions = CardActions;

    constructor(private dialogRef: MatDialogRef<UserCardRequestApprovalNotNeededDialogComponent>) {}

    closeDialog(value?: boolean): void {
        this.dialogRef.close(value);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
